import { useStores } from '@littlebird/sdk';

import { storeMeetingToMeeting } from '../meeting-mapper';
import { meetingStore } from '../meetings.state';

import type { Meeting, MeetingId } from '../meetings.types';

export function useMeetingWithoutTranscript(meetingId?: MeetingId): {
  meeting: Omit<Meeting, 'personified_transcript'> | undefined;
  isMeetingBeingRecorded: boolean;
} {
  const { meetings } = useStores();
  const storeMeeting = meetingId ? meetings.get(meetingId) : undefined;
  const { recording } = meetingStore;
  const isRecordingMeeting = meetingStore.isMeetingIdRecording(meetingId);
  const isMeetingBeingRecorded =
    recording.status === 'recording' && isRecordingMeeting;

  return {
    meeting: storeMeetingToMeeting(storeMeeting),
    isMeetingBeingRecorded,
  };
}
